import { useTranslation } from "react-i18next";
import { boolean, number, object, string } from "yup";

export const CharacterSettingSchema = () => {
    const { t } = useTranslation();
    const schema = {
        gpt_model_id: string(),
        rag_model_id: string().required(),
        enable_context: boolean().required(),
        max_context_words: number().when("enable_context", {
            is: true,
            then: (schema) =>
                schema
                    .transform((value, originalValue) => {
                        return typeof originalValue === "string" && originalValue.trim() === "" ? undefined : value;
                    })
                    .test("no-leading-zero", `${t("CH.Context_LeaderZero")} `, (value) => {
                        if (value !== undefined && value !== null) {
                            const strValue = value.toString();
                            return !/^0/.test(strValue);
                        }
                        return true;
                    })
                    .min(1, `${t("CH.Context_Word_Limit")} `)
                    .max(2000, `${t("CH.Context_Word_Limit")} `)
                    .required(`${t("COMMON.Required_Input")} `),
            otherwise: (schema) => schema.strip(),
        }),
        enable_hint: boolean().required(),
        task_type: string(), //單選
        service_type: string(),
        rag_setting: object()
            .optional()
            .shape({
                dense_top_k: number(),
                score_threshold: number(),
                sparse_top_k: number(),
                top_k: number(),
                max_doc_segments: number()
                    .transform((value, originalValue) => {
                        if (originalValue === null || originalValue === undefined) {
                            return undefined;
                        }
                        if (typeof originalValue === "string" && originalValue.trim() === "") {
                            return undefined;
                        }
                        return value;
                    })
                    .typeError(`${t("COMMON.VALID_NUMBER") || "請輸入有效的數字"}`)
                    .min(0, `${t("CH.MAX_DOC_SEGMENTS_RANGE") || "最大文檔段落數必須介於0至15000之間"}`)
                    .max(15000, `${t("CH.MAX_DOC_SEGMENTS_RANGE") || "最大文檔段落數必須介於0至15000之間"}`)
                    .integer(`${t("CH.MAX_DOC_SEGMENTS_INTEGER") || "最大文檔段落數必須為整數"}`)
                    .default(6000),
                use_references: boolean().default(false),
            }),
    };
    return object().shape(schema);
};
